import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { X } from "lucide-react";

const DISMISS_KEY = "ls_banner_dismissed";
const DISMISS_HOURS = 24;
const STYLE_COLORS = {
    info: { bg: "rgba(245,176,39,0.10)", border: "rgba(245,176,39,0.4)", text: "var(--ls-gold)" },
    promo: { bg: "rgba(231,76,60,0.12)", border: "rgba(231,76,60,0.5)", text: "var(--ls-red)" },
    warning: { bg: "rgba(231,76,60,0.18)", border: "rgba(231,76,60,0.6)", text: "var(--ls-red)" },
};

export const SiteBanner = () => {
    const [banner, setBanner] = useState(null);
    const [dismissed, setDismissed] = useState(false);

    useEffect(() => {
        try {
            const raw = localStorage.getItem(DISMISS_KEY);
            if (raw) {
                const { id, until } = JSON.parse(raw);
                if (until && Date.now() < until) setDismissed(id);
            }
        } catch { /* ignore */ }
        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/banners/active`)
            .then((r) => r.json())
            .then((d) => setBanner(d.banner))
            .catch(() => setBanner(null));
    }, []);

    if (!banner || dismissed === banner.id) return null;
    const c = STYLE_COLORS[banner.style] || STYLE_COLORS.info;
    return (
        <div role="region" aria-label="Site announcement"
            data-testid="site-banner"
            style={{ position: "relative", zIndex: 50, background: c.bg, borderBottom: `1px solid ${c.border}`, color: c.text, fontSize: 13, padding: "10px 18px", textAlign: "center" }}>
            <span data-testid="site-banner-message">
                <ReactMarkdown components={{ p: ({ children }) => <span>{children}</span> }}>{banner.message}</ReactMarkdown>
            </span>
            {banner.link_url && (
                <a href={banner.link_url} target="_blank" rel="noopener noreferrer"
                    data-testid="site-banner-link"
                    style={{ color: c.text, fontWeight: 600, textDecoration: "underline", marginLeft: 8 }}>
                    {banner.link_label || "Learn more"}
                </a>
            )}
            <button data-testid="site-banner-dismiss" onClick={() => {
                try {
                    localStorage.setItem(DISMISS_KEY, JSON.stringify({ id: banner.id, until: Date.now() + DISMISS_HOURS * 60 * 60 * 1000 }));
                } catch { /* ignore */ }
                setDismissed(banner.id);
            }} aria-label="Dismiss announcement"
                style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", background: "transparent", border: "none", color: c.text, cursor: "pointer" }}>
                <X size={14} />
            </button>
        </div>
    );
};

export default SiteBanner;
